import { render } from "./ordentrabajoresultadoconguia.vue?vue&type=template&id=046961d4&scoped=true"
import script from "./ordentrabajoresultadoconguia.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoconguia.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoconguia.vue?vue&type=style&index=0&id=046961d4&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046961d4"]])

export default __exports__